//changes from haseeb.

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { UsePortalApi } from "../../../utils/UsePortalApi";

export const MessagingRecipients = createAsyncThunk(
  "MessagingRecipients",
  async (payload, { dispatch, getState }) => {
    try {
      dispatch(gettingMessagingRecipients(""));
      const response = await UsePortalApi(
        `Patient/MessagingRecipients`,
        "Post",
        payload,
        true
      );
      if (response) {
        console.log(response, "response");
        dispatch(gettingMessagingRecipientsSuccess(response[0].entry));
      } else {
        dispatch(gettingMessagingRecipientsFailed(response?.errorMessage));
      }
    } catch (error) {
      dispatch(gettingMessagingRecipientsFailed(error));
    }
  }
);
const MessagingRecipientsSlice = createSlice({
    name: "MessagingRecipients",
    initialState: {
      MessagingRecipientsData: null,
      isMessagingRecipients: false,
      errorMessagingRecipients: false,
    },
    reducers: {
      gettingMessagingRecipients: (state, action) => {
        state.MessagingRecipientsData = null;
        state.isMessagingRecipients = true;
        state.errorMessagingRecipients = false;
      },
      gettingMessagingRecipientsSuccess: (state, action) => {
        state.MessagingRecipientsData = action.payload;
        state.isMessagingRecipients = false;
        state.errorMessagingRecipients = false;
      },
      gettingMessagingRecipientsFailed: (state, action) => {
        state.MessagingRecipientsData = null;
        state.isMessagingRecipients = false;
        state.errorMessagingRecipients = true;
      },
      gettingMessagingRecipientsClear: (state, action) => {
        state.MessagingRecipientsData = null;
        state.isMessagingRecipients = false;
        state.errorMessagingRecipients = false;
      },
    },
});
export const {
  gettingMessagingRecipients,
  gettingMessagingRecipientsSuccess,
  gettingMessagingRecipientsFailed,
  gettingMessagingRecipientsClear,
} = MessagingRecipientsSlice.actions;
export default MessagingRecipientsSlice.reducer;
